// src/services/settingsApi.ts
// Instance-wide настройки бэкенда (размеры загрузки по типам процессов, в МБ).
// Контракт: GET /settings → Settings, POST /settings → частичное обновление.
import apiReq from 'core/api';

/** Лимиты размера загрузки по типам процессов (МБ) */
export interface InstanceUploadMaxSize {
  transcription: number;
  summarization: number;
  agreement_extraction: number;
  /** Размер файлов сценария и чата (контекстные документы) */
  context_document_parsing: number;
}

export interface InstanceSettings {
  upload_max_size: InstanceUploadMaxSize;
}

/** Границы значения размера (МБ), заданные бэкендом в UpdateSettingsForm */
export const UPLOAD_MAX_SIZE_MIN_MB = 1;
export const UPLOAD_MAX_SIZE_MAX_MB = 102400;

/** Получить настройки инстанса */
export const getInstanceSettings = async (): Promise<InstanceSettings | undefined> =>
  apiReq<InstanceSettings>('settings');

/**
 * Обновить лимит размера контекстных документов (файлы сценария и чата), в МБ.
 * Частичное обновление: меняется только переданное поле.
 */
export const updateContextDocumentMaxSize = async (
  megabytes: number
): Promise<InstanceSettings | undefined> =>
  apiReq<InstanceSettings>('settings', 'POST', {
    upload_max_size_context_document_parsing: megabytes,
  });
